import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';

import {pushRoute} from '../../../routes';
import contextServices from '../../../services';
import {IError, IResponse20x, IRxAxiosError} from '../../types';

function MyApp() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    contextServices.http.listenError().subscribe(handleError);
    contextServices.http.listenSuccess().subscribe(handleSuccess);
  }, []);

  const handleSuccess = (response: IResponse20x) => {
    if (response && response.message && response.status === 'success') {
      enqueueSnackbar(response.message, {
        variant: 'success',
        anchorOrigin: {vertical: 'top', horizontal: 'right'},
      });
    }
  };

  const handleError = (error: IRxAxiosError) => {
    const {message, apiErrorResponse} = error;

    if (!apiErrorResponse) {
      return;
    }

    if (+apiErrorResponse.error.http_code === 500) {
      enqueueSnackbar(t('erros.erro-500'), {
        variant: 'error',
      });
      return;
    }

    if (
      apiErrorResponse.error.code === 'token_expired' ||
      (+apiErrorResponse.error.http_code === 401 &&
        apiErrorResponse.error.code !== 'WRONG_ARGS')
    ) {
      dispatch(pushRoute('auth'));
    }

    if (apiErrorResponse.error.code === 'ROUND_CLOSED') {
      enqueueSnackbar(message, {variant: 'warning'});
      dispatch(pushRoute('home'));
    }

    if (apiErrorResponse.error.validation) {
      handleErrorValidation(apiErrorResponse.error, apiErrorResponse.message);
    } else if ([400, 401, 301].includes(apiErrorResponse.error.http_code)) {
      enqueueSnackbar(message, {variant: 'warning'});
    }
  };

  const handleErrorValidation = (error: IError, message?: string) => {
    const validation = error.validation || {};
    const flatten = Object.keys(validation).reduce((r: string[], k: string) => {
      const rules = validation[k] || [];
      r = [...r, ...rules];
      return r;
    }, []);

    enqueueSnackbar(
      <div>
        <h4>{message}</h4>
        <ul>
          {flatten.map((m, i) => (
            <li key={i.toString()}>{m}</li>
          ))}
        </ul>
      </div>,
      {variant: 'warning'}
    );
  };

  return <React.Fragment />;
}
export default MyApp;



// WEBPACK FOOTER //
// ./src/shared/components/toastMessage/Toast.tsx